import { useState, useEffect } from 'react';

function AI_Carousel() {
    const [active, setActive] = useState(0);
    
    const AI_slides = [
        { img: require('../img/AI_picture_1.png')},
        { img: require('../img/AI_picture_2.png')},
        { img: require('../img/AI_picture_3.png')}
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActive(prev => (prev + 1) % AI_slides.length);
           }, 3000);
            return () => clearInterval(interval);
    }, []);

    const getPosIndex = (i) => {
        const total = AI_slides.length;
        return (i - active + total) % total;
    };

    const positions = [
        { // center — front
            left: '50%',
            translateX: '-45%',
            scale: 1,
            zIndex: 3,
            opacity: 1,
        },
        { // right — behind
            left: '70%',
            translateX: '-25%',
            scale: 0.88,
            zIndex: 2,
            opacity: 0.85,
        },
        { // left — behind
            left: '30%',
            translateX: '-65%',
            scale: 0.88,
            zIndex: 2,
            opacity: 0.85,
        },
    ];

    const mobilePositions = [
        { // center — front
        left: '50%',
        translateX: '-50%',
        scale: 1,
        zIndex: 3,
        opacity: 1,
        },
        { // right — behind
        left: '60%',
        translateX: '-40%',
        scale: 0.88,
        zIndex: 2,
        opacity: 0.85,
        },
        { // left — behind
        left: '40%',
        translateX: '-60%',
        scale: 0.88,
        zIndex: 2,
        opacity: 0.85,
        },
    ];

    return (
        <div className='AICarouselSection'>
            <div className='AICarouselStack MobileHidden'>
                {AI_slides.map((slide, i) => {
                const pos = positions[getPosIndex(i)];
                return (
                    <div
                    key={i}
                    className='AICarouselCard'
                    style={{
                        left: pos.left,
                        zIndex: pos.zIndex,
                        opacity: pos.opacity,
                        transform: `translateX(${pos.translateX}) scale(${pos.scale})`,
                    }}
                    >
                    <img src={slide.img} className='AICarouselImg' />
                    </div>
                );
                })}
            </div>

            <div className='CarouselStack MobileOnly AICarouselStack'>
            {AI_slides.map((slide, i) => {
                const pos = mobilePositions[getPosIndex(i)];
                return (
                    <div
                    key={i}
                    className='AICarouselCard'
                    style={{
                        left: pos.left,
                        zIndex: pos.zIndex,
                        opacity: pos.opacity,
                        transform: `translateX(${pos.translateX}) scale(${pos.scale})`,
                    }}
                    >
                    <img src={slide.img} className='AICarouselImg' />
                    </div>
                );
            })}
        </div>
        </div>
    );
}

export default AI_Carousel;